import React from 'react';
import { Animated, StyleSheet, View, useWindowDimensions } from 'react-native';
import { Platform } from 'utils/platform';

interface HeroImageProps {
  image?: CmsImage;
  image_vertical?: CmsImage;
}

const CarouselImage: React.FC<HeroImageProps> = ({ image, image_vertical }) => {
  const { width: screenWidth } = useWindowDimensions();
  const fadeAnim = React.useRef(new Animated.Value(0)).current;

  React.useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 800,
      useNativeDriver: true,
    }).start();
  }, []);

  return (
    <View
      style={[
        styles.container,
        {
          width: Platform.isAndroidTV ? screenWidth : '100%',
          borderRadius: screenWidth > 500 ? 16 : 0, // $2xl = 16, $none = 0
        },
      ]}>
      {image_vertical?.url ? (
        <Animated.Image
          style={[styles.image, { opacity: fadeAnim }]}
          alt={image?.title}
          source={{ uri: image_vertical?.url }}
        />
      ) : (
        <Animated.Image
          style={[styles.image, { opacity: fadeAnim }]}
          alt={image?.title}
          source={{ uri: image?.url }}
        />
      )}
    </View>
  );
};

export default CarouselImage;

const styles = StyleSheet.create({
  container: {
    height: '100%',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
  },
});
